import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Inject, Injectable } from '@angular/core';
import { SCREEN_LAYOUT, ScreenLayout } from '../core/layout/layout.provider';
import { DataService } from '../data/data.service';
import { ProductDetailsComponent } from './product-details.component';

@Injectable({providedIn: 'root'})
export class ProductDetailsService {
  constructor(public readonly modalService: NgbModal,
              @Inject(SCREEN_LAYOUT) private readonly layout: ScreenLayout,
              private readonly dataService: DataService) {
  }

  async openProductInfoModal(id: number) {
    const product = await this.dataService.fetchProduct(id);
    const modal = this.modalService.open(ProductDetailsComponent, {
      modalDialogClass: [
        'rounded-content',
        'modal-fullscreen',
        ( this.layout == ScreenLayout.desktop ? 'p-5' : 'p-2')
      ].join(' '),
    });

    modal.componentInstance.product = product;
    await modal.result.then(result => result, () => false);
  }
}
